module.exports = __webpack_public_path__ + "img/softinya-prop-2.b97ede67.webp";